import img from "../images/vet/mfban_ratio.jpeg";
import notice_1 from "../images/resource/images/코벳엑스칼리버.jpeg";
import notice_2 from "../images/resource/images/스카이현판.jpeg";
import notice_3 from "../images/resource/images/스카이유기동물사료.jpeg";
import notice_4 from "../images/resource/images/구월지웰시티푸르지오_인천스카이동물메디컬센터_주차_안내_1.jpeg";
import notice_5 from "../images/title/visual_incheon.jpeg";
import notice_6 from "../images/resource/images/진료비안내_인천점_1.PNG";
import notice_7 from "../images/resource/images/진료비안내_인천점_2.PNG";

// import notice_1 from "../images/resource/images/코벳엑스칼리버.jpeg";
// import notice_1 from "../images/resource/images/코벳엑스칼리버.jpeg";

//? 관련 이미지가 없는 경우, 빈 문자열 넣어주세요

const notice = [
  {
    id: 7,
    title: `진료비안내`,
    content: `안녕하세요.
인천SKY동물메디컬센터 입니다.

인천SKY동물메디컬센터 진료비에 대해 안내드립니다.

앞으로 더욱 노력하는 SKY동물메디컬그룹이 되겠습니다.
감사합니다.

수의사법 제 320조(진찰 등의 진료비용 게시) 및 수의사법 시행규칙 제18조의 3
(진찰 등의 진료비용 게시 대상 및 방법)에 다라 다음과 같이 고지합니다.
`,
    img: notice_6,
    img_sub: notice_7,
  },
  {
    id: 6,
    title: `봉사활동을 다녀 왔습니다~  ^^ _ 서울 용산 나비야사랑해`,
    content: `안녕하세요 인천시 남동구 구월동에 위치한 인천24시동물병원 인천스카이동물메디컬센터 입니다.`,
    img: "https://mblogthumb-phinf.pstatic.net/MjAyMzEyMDRfMjEw/MDAxNzAxNjc1MTU3ODUx.WjAt75KGAAiRPPaQimGEITvN764_lsDe4DDmZUaD9VUg.4_oxi3wnf_I8OYCILp4WDSFCR1Ue2bIOhtBPmU0kfEgg.JPEG.skyamg_ic/%EB%82%98%EB%B9%84%EC%95%BC%EC%82%AC%EB%9E%91%ED%95%B4_1.jpg?type=w800",
    link: "https://m.blog.naver.com/skyamg_ic/223282651223"
  },
  {
    id: 4,
    title: `주차안내 및 오시는 길`,
    content: `안녕하세요

인천24시동물병원
인천스카이동물메디컬센터 입니다.

도보로 오시는 경우 ,
인천시청신관의 오피스동과 C동 사이의 gate 6로 들어 오시면
엘리베이터를 이용해 동물병원으로 바로 올라 오실 수 있습니다.

자동차로 오시는 경우,
인천스카이동물메디컬센터가 위치한 구월지웰푸르지오시티는
주차장에 진입하는 방법이 인천시청쪽과 길병원쪽, 2곳입니다.
어디를 이용하셔도 주차장 입구는 한 곳으로 통하니 편하신 곳으로 오시면 됩니다.

차단기가 설치되어 있지만 인천스카이동물메디컬센터에 방문하시면 무료 주차 입니다.
주차장은 지하1층에서 부터 지하 6층까지 약 600여대 정도 주차할 수 있습니다.

지하 2층, 지하 3층에 주차 하시는 경우,
안내 표지판을 따라 gate 2로 들어 오시면 상가전용 엘리베이터를 이용해서 동물병원 으로 바로 올라 오실 수 있습니다.

지하 4층, 지하5층, 지하 6층에 주차 하시는 경우,
상가로 바로 올라 올수 있는 엘리베이터가 없어서 한번 환승을 하셔야 합니다.

[환승 방법]
인천시청별관으로 갈 수 있는 오피스 쪽 입구로 들어 가신 다음 엘리베이터를 이용해 2층에 내리셔야 합니다.
인천시청신관인 오피스동 2층은 동물병원이 있는 C동 1층과 연결되어 있습니다.
인천시청신관 2층에서 C동으로 이동하신 다음 엘리베이터를 이용해 동물병원으로 올라 오실 수 있습니다.

인천시청 앞에 새로 생긴 구월지웰시티푸르지오가 상가 규모가 제법 커서 이동하는 동선이 좀 복잡합니다.
하지만 인천스카이동물메디컬센터는 오피스텔이 있는 C동 3층 전체를 다 사용하기 때문에 밖에서도 찾기 쉽고 엘리베이터로 이용해서 동물병원으로 바로 오실 수 있습니다.

혹시 길이 복잡하시면 병원으로 언제 든지 전화 주세요.
자세히 안내해 드리겠습니다.
`,
    img:
      "https://raw.githubusercontent.com/syjeong-petprice/skyamg/master/src/images/resource/images/%EA%B5%AC%EC%9B%94%EC%A7%80%EC%9B%B0%EC%8B%9C%ED%8B%B0%ED%91%B8%EB%A5%B4%EC%A7%80%EC%98%A4_%EC%9D%B8%EC%B2%9C%EC%8A%A4%EC%B9%B4%EC%9D%B4%EB%8F%99%EB%AC%BC%EB%A9%94%EB%94%94%EC%BB%AC%EC%84%BC%ED%84%B0_%EC%A3%BC%EC%B0%A8_%EC%95%88%EB%82%B4_1.jpeg" ||
      notice_4,
  },
  {
    id: 1,
    title: `더 나은 진료를 위한 영상진단보조 AI - SK 엑스칼리버`,
    content: `스카이동물메디컬그룹의 모든 동물병원은 더 나은 진료를 위한 영상진단보조 AI SK텔레콤 엑스칼리버를 도입하여 반려동물의 건강을 위한 진료에 활용하고 있습니다.

앞으로도 더욱 노력하는 스카이동물메디컬그룹이 되겠습니다.

감사합니다.`,
    img: notice_1,
  },
  {
    id: 2,
    title: `ai동물병원, ai to 동물의료 _ SK텔레콤 엑스칼리버, 스카이동물메디컬센터`,
    content: `안녕하세요. 스카이동물메디컬그룹입니다.

얼마전, 사람과 인공지능의 바둑 대결이 온 세상에 관심을 받으면서
인공지능, AI가 우리 생활에 가까이 왔구나를 느꼈던 적이 있습니다.

하지만 바둑이라는 한정된 분야에만 적용될 것이며, 아직은 좀 먼 미래의 일이 아닌가 라고 생각 했었습니다.

하지만 그 얼마 뒤 openAI사의 Chat GPT가 또 한번 인공지능이라는 현실을 느끼게 해주었습니다.

인공지능, AI는 이제는 결코 멀리 있는게 아닙니다.`,
    img: notice_2,
  },
  {
    id: 3,
    title: `스카이동물메디컬센터에서 퓨리나와 함께 유기동물 보호소에 사료를 기부`,
    content: `스카이동물메디컬그룹에서 인천시 수의사회 유기동물 보소호에 사료를 기부 하였습니다.

유기동물 문제에도 많은 관심이 필요하기 때문에 동물 복지를 위해
퓨리나 에서 많은 도움을 주신 덕분에 기부를 할 수 있게 되었습니다.

앞으로도 반려동물의 건강 뿐만 아니라 동물 복지의 전반적인 분야에서도 항상 관심을 갖고 노력하는 스카이동물메디컬그룹이 되겠습니다.

감사합니다.`,
    img: notice_3,
  },
  {
    id: 5,
    title: `인사말`,
    content: `안녕하세요

인천스카이동물메디컬센터는 인천시청과 길병원 사이 위치 하고 있으며, CT,MRI등 최신의 진단 장비를 갖춘 인천 지역 최대 동물병원 입니다.

인천스카이동물메디컬센터의 모든 구성원은 반려동물의 건강을 위해 항상 최선을 다 한다는 생각으로 초심을 잃지 않기 위해 노력하고 있습니다.

감사합니다.
`,
    img: notice_5,
  },
  // {
  //   id: 6,
  //   title: `제목6`,
  //   content: `내용입니다`,
  //   img: img,
  // },
];

export default notice;
